export default function alphasort(s1: string, s2: string) {
  if (s1.toLowerCase() < s2.toLowerCase()) {
    return -1;
  } else if (s1.toLowerCase() > s2.toLowerCase()) {
    return 1;
  } else {
    return 0;
  }
}
